import { render, staticRenderFns } from "./projectUpload.vue?vue&type=template&id=1baf7f64&"
import script from "./projectUpload.vue?vue&type=script&lang=js&"
export * from "./projectUpload.vue?vue&type=script&lang=js&"
import style0 from "./projectUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports